import React, { useState } from 'react'
import { getImages } from '../../Common/const'
import { motion } from "framer-motion";
import UseScrollReveal from '../../Common/UseScrollReveal';
import BookAppointmentModal from './BookAppointmentModal';
import ModalLayout from '../../Common/ModalLayout';
import { Link } from 'react-router-dom';
import SeoMeta from '../../Common/SeoMeta';

const AudiR8Repair = () => {
    const [position, setPosition] = useState({ x: 0, y: 0 });
    const handleMouseMove = (e) => {
        const { clientX, clientY, currentTarget } = e;
        const { left, top, width, height } = currentTarget.getBoundingClientRect();
        const x = ((clientX - left) / width - 2) * 20;
        const y = ((clientY - top) / height - 1) * 20;
        const bgX = ((clientX - left) / width - 5) * 30;
        const bgY = ((clientY - top) / height - 0.5) * 30;
        setPosition({ x, y, bgX, bgY });
    };
    UseScrollReveal()
    // 
    const [openBookAppointment, setOpenBookAppointment] = useState(false);
    const handleBookAppointment = () => {
        setOpenBookAppointment(true);
        document.body.classList.add('body-overflow');
    }
    const closeBookAppointment = () => {
        setOpenBookAppointment(false)
        document.body.classList.remove('body-overflow');
    }
    return (
        <>
            <SeoMeta
                title="Audi R8 Service & Repair in Tampa, FL | EEC"
                description="Looking for Audi R8 repair services in Tampa? European Exotic Center can help with everything from oil changes to exhaust repair."
                keywords=""
                ogTitle="Audi R8 Service & Repair in Tampa, FL | EEC"
                ogDescription="Looking for Audi R8 repair services in Tampa? European Exotic Center can help with everything from oil changes to exhaust repair."
            />
            <section className="common-banner-wrap repair-banner">
                <img src={getImages('services/Audi-R8-Service-hero.jpg')} alt='Audi R8 Service' />
                <div className="container">
                    <div className='common-banner-pos pt-140 text-center'>
                        <h1 className='banner-lg-title text-uppercase wow reveal fadeInUp'>Audi R8 Service</h1>
                        <div className='md-title font-2em fw-400 text-center mt-3 mb-4 wow reveal fadeInUp'>in the Tampa Bay Area</div>
                        <div className='my-4 wow reveal fadeInUp'>
                            <button type='button' className='orange-white-btn lg-btn w-330 font-1-2em fw-700 text-uppercase' onClick={handleBookAppointment}>Schedule Service</button>
                        </div>
                    </div>
                </div>
            </section>
            <section className='exotic-car-wrap'>
                <div className='container'>
                    <div className='row align-items-center'>
                        <div className='col-12 wow reveal fadeInLeft'>
                            <div className='md-title fw-700 text-uppercase mb-md-5 mb-3'>Audi R8 Services & Auto Repair in Tampa, FL</div>
                            <div className='common-text pb-3'>
                                <p>When you demand excellence, it’s hard to go wrong with an Audi R8. A true feat of engineering, this sports car is well-known for being fast, powerful, and smooth to both ride in and drive.</p>
                                <p>But you don’t just demand excellence for your vehicle. You also demand it from your mechanic and automotive specialists. Rest assured, when you choose European Exotic Center for auto repairs and other Audi R8 services, your vehicle will get the excellent care it deserves.</p>
                            </div>
                            <div className='mt-5 wow reveal fadeInUp d-none d-md-block'>
                                <button type='button' className='orange-white-btn lg-btn w-330 font-1-2em fw-700 text-uppercase' onClick={handleBookAppointment}>Schedule Service</button>
                            </div>
                        </div>
                        {/* <div className='col-md-6 text-end wow reveal fadeInRight mt-md-0 mt-4'>
                            <img src={getImages('bitmap-copy-2.png')} alt='' />
                        </div> */}
                    </div>
                </div>
            </section>
            <section className='maintenance-services-wrap'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-6 pe-5 pt-2 wow reveal fadeInLeft'>
                            <div className='sm-title text-uppercase font-2-5em mb-md-4 mb-3'>Maintenance Services and Repairs We Offer</div>
                            <div className='common-text'>
                                <p>Regular upkeep of your vehicle is critical to keep it running smoothly for years, whether you have a brand-new car or a used Audi R8. Fortunately, we offer a wide range of maintenance and repair services for R8s.</p>
                                <p>Regular automotive services and repair we offer include the following, all at a great price:</p>
                            </div>
                        </div>
                        <div className='col-md-6 wow reveal fadeInRight mt-md-0 mt-5'>
                            <ul className='oe-list-flex'>
                                <li>
                                    <div className='d-flex align-items-center'>
                                        <div className='oe-icon'>
                                            <img src={getImages('arrow.svg')} />
                                        </div>
                                        <div className='sm-title eurostile text-uppercase pt-1'>Annual Services, including major services</div>
                                    </div>
                                </li>
                                <li>
                                    <div className='d-flex align-items-center'>
                                        <div className='oe-icon'>
                                            <img src={getImages('arrow.svg')} />
                                        </div>
                                        <div className='sm-title eurostile text-uppercase pt-1'>Suspension repairs and replacements</div>
                                    </div>
                                </li>
                                <li>
                                    <div className='d-flex align-items-center'>
                                        <div className='oe-icon'>
                                            <img src={getImages('arrow.svg')} />
                                        </div>
                                        <div className='sm-title eurostile text-uppercase pt-1'>AC System diagnostics and repair</div>
                                    </div>
                                </li>
                                <li>
                                    <div className='d-flex align-items-center'>
                                        <div className='oe-icon'>
                                            <img src={getImages('arrow.svg')} />
                                        </div>
                                        <div className='sm-title eurostile text-uppercase pt-1'>Brake and Tire Replacements</div>
                                    </div>
                                </li>
                                <li>
                                    <div className='d-flex align-items-center'>
                                        <div className='oe-icon'>
                                            <img src={getImages('arrow.svg')} />
                                        </div>
                                        <div className='sm-title eurostile text-uppercase pt-1'>Electrical system repair and diagnosis</div>
                                    </div>
                                </li>
                                <li>
                                    <div className='d-flex align-items-center'>
                                        <div className='oe-icon'>
                                            <img src={getImages('arrow.svg')} />
                                        </div>
                                        <div className='sm-title eurostile text-uppercase pt-1'>And many more services!</div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div className='col-12 wow reveal fadeInUp mt-md-5 mt-4 pt-2'>
                            <div className='sm-title text-uppercase font-2-5em mb-4 wow reveal fadeInUp'>Recommended Audi R8 Maintenance Schedule</div>
                            <div className='common-text wow reveal fadeInUp'>
                                <p>Regular maintenance and service intervals will vary based on several factors, including the year and exact model of your vehicle. That said, the following basic maintenance schedule is generally true for various year models and makes of Audi R8s:</p>
                                <ul>
                                    <li>Oil/oil filters: Every 10,000 miles/once a year</li>
                                    <li>Tires: Every year</li>
                                    <li>Brake system: Every year</li>
                                    <li>Brake fluids: Every 2 years</li>
                                    <li>Battery: Every 20,000 miles/2 years</li>
                                    <li>Air filter replacement: Every 60,000 miles</li>
                                </ul>
                                <p>Contact us to get more information on the recommended service and maintenance intervals based on your Audi R8’s specs.</p>
                            </div>
                        </div>
                        <div className='col-12 wow reveal fadeInUp mt-md-5 mt-4 pt-2'>
                            <div className='sm-title text-uppercase font-2-5em mb-4 wow reveal fadeInUp'>Latest Audi R8 Models</div>
                            <div className='common-text wow reveal fadeInUp'>
                                <p>The latest from this manufacturer, the 2022 R8 Coupe, is available in two trim levels: the 5.2 Quattro V10 Performance (all-wheel drive/AWD) and 5.2 V10 performance (rear-wheel drive/RWD). Both include luxuries the brand is known for, including leather seats and heated steering wheels. The company also offers the Audi R8 Spyder for fans of luxury convertibles. No matter which year, make, model, or trim level you choose, you can be sure you’re getting a vehicle that demands attention wherever you go.</p>
                            </div>
                        </div>
                        <div className='col-12 wow reveal fadeInUp mt-md-5 mt-4 pt-2'>
                            <div className='sm-title text-uppercase font-2-5em mb-4 wow reveal fadeInUp'>Why European Exotic Center is the Right Choice</div>
                            <div className='common-text wow reveal fadeInUp'>
                                <p>We’re the one-stop destination for all things related to exotic vehicles in and around Tampa, Florida, including nearby Sarasota, Orlando, Clearwater, and Miami. And we want to be your local Audi dealership and service center of choice.</p>
                                <p>European Exotic Center is a family-owned, luxury certified pre-owned vehicle dealership and world-class service center. Our expert team has years of experience working with high-end makes and models of all kinds of supercars, including R8s, <Link to="/porsche-repair">Porsches</Link>, and <Link to="/lamborghini-repair">Lamborghinis</Link>. Our commitment to excellence has earned us the honor of being one of the only factory-licensed <Link to="/koenigsegg-repair">Koenigsegg service centers</Link> in the Southeast.</p>
                                <p>Not only do we care for your vehicle, we're competitively priced. Our Audi R8 services are sometimes half the cost of nearby dealerships, who frankly aren't as good as we are. </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='book-appointment-wrap dtl-book-appoint-wrap'>
                <div className="mouse-container"
                    onMouseMove={handleMouseMove}>
                    <motion.div
                        className="mouse-background"
                        style={{
                            background: `url(${getImages('ferrari-schedule-bg.webp')}) no-repeat center/cover`
                        }}
                        animate={{
                            x: position.bgX,
                            y: position.bgY,
                        }}
                        transition={{ type: "tween", stiffness: 50 }}
                    />

                    <div className='w-100 text-center mouse-text'>
                        <div className='container'>
                            <div className='banner-lg-title font-3-5em text-uppercase wow reveal fadeInUp'>schedule an appointment</div>
                            <div className='sm-title font-1-2em mt-3 wow reveal fadeInUp'>We would love to work with you and have the opportunity to service your unique vehicle.</div>
                            <div className="my-4 wow reveal fadeInUp">
                                <button type="button" className="orange-white-btn lg-btn w-330 font-1-2em fw-700 text-uppercase" onClick={handleBookAppointment}>Schedule Service</button>
                            </div>
                            <div className='text-center wow reveal fadeInUp'>
                                <a href='tel:8135880905' className='sm-title font-1-5em fw-400 avenir-next text-white'>
                                    Or Call (813) 588-0905
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='fs-schedule-services-wrap'>
                <div className='container'>
                    <div className='banner-lg-title font-2-5em mb-md-4 mb-3 pb-md-2 text-uppercase wow reveal fadeInUp'>Schedule Service in Tampa, FL</div>
                    <div className='sm-title font-1-2em wow reveal fadeInUp'>Whether you have a new vehicle or a used car, we know how special your supercar is. We look forward to working with you and having the opportunity to service your unique Audi vehicle. Contact us today by phone (813-548-3552) to schedule an appointment with our service department.</div>
                </div>
            </section>
            {openBookAppointment &&
                <ModalLayout open={openBookAppointment} close={closeBookAppointment} darkThemeCls='true' modalWidth={1030}>
                    <BookAppointmentModal close={closeBookAppointment} />
                </ModalLayout>
            }
        </>
    )
}
export default AudiR8Repair
